export default __webpack_public_path__ + "9e8d5ab090568c99215e4df8b9a45947.svg";